export default __webpack_public_path__ + "assets/images/0736cd2afcb90d9f6594665789ad4812.png";